export const logoutChannel = new BroadcastChannel("logout");
